import { render, staticRenderFns } from "./PersonGrid.vue?vue&type=template&id=4c9c56aa"
import script from "./PersonGrid.vue?vue&type=script&lang=js"
export * from "./PersonGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports